import LlmTipsWidgetView from './LlmTipsWidgetView.vue';

export const type = 'llmTips';
export const view = LlmTipsWidgetView;

export function builder() {
  return {
    type,
    top: 0,
    rotate: 0,
    height: 200,
    width: 350,
    zIndex: 1,
    fontColor: '#000000',
    amountFontColor: '#008800',
    fontFamily: 'SimplerPro',
    variableData: [],
    variableName: '',
    boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
    gap: 15,
    marginLeft: 30,
  };
}
